export enum Filters {
    OrganizationId = "organizationId",
    OrganizationType = "typeCode",
    LogexLegacyCode = "logexLegacyCode",
    MRDMLegacyCode = "mrdmLegacyCode",
    Country = "countryCode",
    ExcludeInactiveOrganizations = "excludeInactiveOrganizations",
    LogInitiator = "logInitiator",
    Date = "date",
    AffiliationId = "affiliationId",
    Category = "categoryName",
    CoinsLegacyCode = "coinsLegacyCode",
    AgbCode = "agbCode",
    NhsCode = "nhsCode",
    Lanskod = "lanskod",
    Brreg = "brreg"
}
